import { createFileRoute, Navigate, useLocation } from '@tanstack/react-router';
import { OtpWrapper, VerifyUser } from '@amber-ui/core';

function OtpVerifyEmail() {
  const { searchStr } = useLocation();
  const searchParams = new URLSearchParams(searchStr);
  const otp = searchParams.get('otp');
  if (!otp) return <Navigate to="/otp/error" replace />;
  return (
    <OtpWrapper token={otp}>
      <VerifyUser token={otp} />
    </OtpWrapper>
  );
}

export const Route = createFileRoute('/otp/verify_email')({
  component: OtpVerifyEmail,
});
